import {RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const LCRadarChart = ({ data = [] }) => {

  if (data.length === 0) return null;
  const keys = Object.keys(data[0]);
  const angleKey = keys[0];
  const valueKeys = keys.slice(1);

  const COLORS = ['#0a2463','#b0c4de'];

  return (
    <ResponsiveContainer width="100%" height={400}>
      <RadarChart data={data}>
        <PolarGrid />
        <Tooltip />
        <PolarAngleAxis dataKey={angleKey} />
        <PolarRadiusAxis />
        {valueKeys.map((key, index) => (
          <Radar
            key={key}
            name={key}
            dataKey={key}
            stroke={COLORS[index % COLORS.length]}
            fill={COLORS[index % COLORS.length]}
            fillOpacity={0.6}
          />
        ))}
        <Legend />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default LCRadarChart;

  
                              


